export function basename(path: string): string {
  const parts = path.split('/');
  return parts[parts.length - 1] || path;
}

/** `memory/2026-07-15.md` → midnight UTC ISO for that day; undefined when the name carries no valid date. */
export function dateFromName(name: string): string | undefined {
  const match = /(\d{4})-(\d{2})-(\d{2})/.exec(basename(name));
  if (!match) return undefined;
  const iso = `${match[1]}-${match[2]}-${match[3]}T00:00:00.000Z`;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) || !date.toISOString().startsWith(`${match[1]}-${match[2]}-${match[3]}`)
    ? undefined
    : iso;
}

/** Pull `description:` out of a YAML frontmatter block without a YAML parser. */
export function frontmatterDescription(text: string): string | undefined {
  if (!text.startsWith('---')) return undefined;
  const end = text.indexOf('\n---', 3);
  if (end === -1) return undefined;
  const block = text.slice(3, end);
  const line = block.split('\n').find((l) => /^description:/i.test(l.trim()));
  if (!line) return undefined;
  const value = line.slice(line.indexOf(':') + 1).trim().replace(/^["']|["']$/g, '');
  return value.length > 0 ? value : undefined;
}
